import axios from 'axios';

// Construct full API URL: base URL from env + API version path
const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

const axiosInstance = axios.create({
    baseURL: baseURL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance; 